import MentoringMeetingStatus from './MentoringMeetingStatus.vue';

export default MentoringMeetingStatus;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/modal/components/meeting/components/status/index.ts